import { ApiResponseCodeEnum } from "./ApiResponseCodeEnum";

export class ApiResponse {
  response: ApiResponseCodeEnum;
  message: string;
  payload: object;

  constructor(response: ApiResponseCodeEnum, message: string, payload: object) {
    this.response = response;
    this.message = message;
    this.payload = payload;
  }

  public static FromAxiosResponse(res: any) {
    return new ApiResponse(res.data.Response as ApiResponseCodeEnum, res.data.Message, res.data.Payload);
  }
}
